import { createSlotRecipe } from './runtime.js';

const indicatorConfig = {"name":"indicator","slots":["root","dot","visual"],"defaultVariants":{"size":"md"},"variantMap":{"size":["md","sm"]}}

export const indicator = /* @__PURE__ */ createSlotRecipe(indicatorConfig)